/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurchaseOrderUpsertRequest
 */
export interface PurchaseOrderUpsertRequest {
    /**
     * The internal purchaseOrder registration id if exists
     * @type {string}
     * @memberof PurchaseOrderUpsertRequest
     */
    id?: string;
    /**
     * The purchaseOrder number of the client
     * @type {string}
     * @memberof PurchaseOrderUpsertRequest
     */
    identifier: string;
    /**
     * The budget amount (including taxes) allowed by this purchase order
     * @type {number}
     * @memberof PurchaseOrderUpsertRequest
     */
    budget?: number;
    /**
     * A simple comment to insert along with the purchase order
     * @type {string}
     * @memberof PurchaseOrderUpsertRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the PurchaseOrderUpsertRequest interface.
 */
export function instanceOfPurchaseOrderUpsertRequest(value: object): value is PurchaseOrderUpsertRequest {
    if (!('identifier' in value) || value['identifier'] === undefined) return false;
    return true;
}

export function PurchaseOrderUpsertRequestFromJSON(json: any): PurchaseOrderUpsertRequest {
    return PurchaseOrderUpsertRequestFromJSONTyped(json, false);
}

export function PurchaseOrderUpsertRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseOrderUpsertRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'identifier': json['identifier'],
        'budget': json['budget'] == null ? undefined : json['budget'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function PurchaseOrderUpsertRequestToJSON(value?: PurchaseOrderUpsertRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'identifier': value['identifier'],
        'budget': value['budget'],
        'comment': value['comment'],
    };
}

